export default "__VITE_ASSET__BH$Ebaj___"